import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { TwoStepVarificationComponent } from './two-step-varification/two-step-varification.component';


@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
  ],
  declarations: [AuthRoutingModule.components, SignInComponent, SignUpComponent, ResetPasswordComponent, ErrorPageComponent, TwoStepVarificationComponent],
  providers: []
})
export class AuthModule { }